const familyBabyRecipes = [
  // ============================================================
  // BABY WEANING (6-12 months) — 8 recipes
  // NHS weaning guidance: no honey under 12 months, no added salt
  // or sugar, no whole nuts, quarter any grapes, age-appropriate
  // textures, fully cooked eggs unless British Lion stamped.
  // ============================================================
  {
    title: 'Butternut Squash and Pear Puree (Baby Weaning, 6+ Months)',
    description: 'A velvety first puree pairing sweet roasted butternut squash with ripe pear, ideal from 6 months. Naturally sweet with no added sugar or salt, and easily loosened with your baby\'s usual milk. Safety note: always check the temperature before serving and never add honey for babies under 12 months.',
    images: [],
    sourceUrl: '',
    servings: 6,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Baby Food'],
    tags: ['gluten-free', 'dairy-free', 'vegan', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'freezer-friendly', 'batch-cooking', '5-ingredients-or-less'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 45, protein: 0.7, carbs: 11, fat: 0.1, fiber: 2, sugar: 6, sodium: 3, iron: 0.4,
    },

    ingredients: [
      { qty: 400, unit: 'g', item: 'butternut squash, peeled and cubed', group: 'Main' },
      { qty: 1, unit: 'ripe', item: 'pear, peeled, cored and chopped', group: 'Main' },
      { qty: 60, unit: 'ml', item: 'water or baby\'s usual milk', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Peel the squash, scoop out the seeds and cut into 2 cm cubes.', timerMinutes: null },
      { order: 2, instruction: 'Steam the squash cubes over simmering water until completely tender when pierced with a fork.', timerMinutes: 15 },
      { order: 3, instruction: 'Add the chopped pear to the steamer for the final few minutes until soft.', timerMinutes: 5 },
      { order: 4, instruction: 'Blend the squash and pear until silky smooth, adding water or your baby\'s usual milk a splash at a time to reach the right consistency for their stage.', timerMinutes: null },
      { order: 5, instruction: 'Cool to lukewarm and test the temperature on the inside of your wrist before serving.', timerMinutes: null },
      { order: 6, instruction: 'Freeze leftovers in an ice cube tray, then transfer the cubes to a freezer bag for up to 3 months.', timerMinutes: null },
    ],
    notes: 'Suitable from 6 months. No added salt or sugar — babies\' kidneys cannot handle salt, and NHS guidance says never give honey before 12 months because of the risk of infant botulism. From around 7 months, blend less for a thicker, lumpier texture to help your baby learn to chew.',

    communityRating: 4.8,
    communityRatingCount: 62,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Courgette and Potato Baby Mash (6+ Months)',
    description: 'A gentle green mash of steamed courgette and fluffy potato, perfect for introducing savoury flavours from 6 months. Made with no added salt and finished with a little of your baby\'s usual milk. Safety note: check the temperature before serving; never add honey under 12 months.',
    images: [],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 15,
    totalTime: 25,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Baby Food'],
    tags: ['gluten-free', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'vegetarian', 'under-30-min', 'freezer-friendly', '5-ingredients-or-less', 'budget-friendly'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 50, protein: 1.3, carbs: 10, fat: 0.4, fiber: 1.5, sugar: 2, sodium: 6, iron: 0.4,
    },

    ingredients: [
      { qty: 1, unit: 'medium', item: 'potato, peeled and cubed', group: 'Main' },
      { qty: 1, unit: 'small', item: 'courgette, trimmed and sliced', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'baby\'s usual milk (or water)', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Peel and cube the potato. Trim the courgette and cut into thick slices — no need to peel.', timerMinutes: null },
      { order: 2, instruction: 'Steam the potato until nearly tender.', timerMinutes: 8 },
      { order: 3, instruction: 'Add the courgette slices and steam until both vegetables are very soft.', timerMinutes: 6 },
      { order: 4, instruction: 'Mash or blend with your baby\'s usual milk to the texture that suits their stage — silky smooth for first tastes, or roughly mashed with soft lumps from around 7 months.', timerMinutes: null },
      { order: 5, instruction: 'Cool to lukewarm, test on the inside of your wrist, and serve.', timerMinutes: null },
    ],
    notes: 'Suitable from 6 months. No added salt — season nothing for babies under 12 months. Courgette holds a lot of water, so drain well before mashing. Freeze in cubes for up to 3 months and defrost overnight in the fridge.',

    communityRating: 4.6,
    communityRatingCount: 41,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Banana and Avocado Baby Mash (No-Cook, 6+ Months)',
    description: 'A no-cook, two-ingredient mash of ripe banana and creamy avocado — the ultimate speedy baby meal from 6 months, packed with healthy fats for growing brains. Safety note: serve freshly made, check the texture is smooth enough for your baby\'s stage, and never add honey under 12 months.',
    images: [],
    sourceUrl: '',
    servings: 2,
    prepTime: 5,
    cookTime: 0,
    totalTime: 5,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Baby Food'],
    tags: ['gluten-free', 'dairy-free', 'vegan', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'no-cook', 'under-15-min', '5-ingredients-or-less'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 90, protein: 1, carbs: 12, fat: 5, fiber: 3, sugar: 7, sodium: 3, iron: 0.4,
    },

    ingredients: [
      { qty: 0.5, unit: 'ripe', item: 'banana', group: 'Main' },
      { qty: 0.5, unit: 'ripe', item: 'avocado', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Peel the banana and scoop the avocado flesh into a bowl.', timerMinutes: null },
      { order: 2, instruction: 'Mash together with a fork until smooth and creamy. For younger babies, push through a sieve or blend with a splash of your baby\'s usual milk for an extra-smooth finish.', timerMinutes: null },
      { order: 3, instruction: 'Serve straight away — from around 6 months it can also be spread thinly on lightly toasted fingers of bread as a first finger food.', timerMinutes: null },
    ],
    notes: 'Suitable from 6 months. Use ripe fruit only — it should mash with no lumps. This browns quickly, so make it fresh each time rather than storing. No added sugar or salt, and never honey under 12 months.',

    communityRating: 4.7,
    communityRatingCount: 58,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Baby Porridge Fingers (Baby-Led Weaning, 6+ Months)',
    description: 'Soft, squishable oat fingers your baby can hold themselves — brilliant for baby-led weaning from 6 months. Just oats, milk and banana, baked into bars that hold together without crumbling. Safety note: always supervise finger foods, sit baby upright, and never add honey under 12 months.',
    images: [],
    sourceUrl: '',
    servings: 8,
    prepTime: 5,
    cookTime: 15,
    totalTime: 20,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Baby Food', 'Breakfast'],
    tags: ['nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'vegetarian', 'under-30-min', 'freezer-friendly', 'batch-cooking', '5-ingredients-or-less', 'budget-friendly'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 55, protein: 1.8, carbs: 9, fat: 1.2, fiber: 1, sugar: 2, sodium: 8, iron: 0.5,
    },

    ingredients: [
      { qty: 100, unit: 'g', item: 'porridge oats', group: 'Main' },
      { qty: 150, unit: 'ml', item: 'whole milk (or baby\'s usual milk)', group: 'Main' },
      { qty: 1, unit: 'ripe', item: 'banana, mashed', group: 'Main' },
      { qty: 0.25, unit: 'tsp', item: 'ground cinnamon (optional)', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat the oven to 180°C fan and line a small baking tin with baking paper.', timerMinutes: null },
      { order: 2, instruction: 'Mix the oats, milk, mashed banana and cinnamon, if using, into a thick porridge.', timerMinutes: null },
      { order: 3, instruction: 'Press the mixture into the tin about 1.5 cm deep and bake until set and lightly golden.', timerMinutes: 15 },
      { order: 4, instruction: 'Cool completely, then cut into chunky fingers about the size of an adult finger — easy for little fists to grip.', timerMinutes: null },
      { order: 5, instruction: 'Serve soft, never crunchy. Check each finger squashes easily between your thumb and forefinger before offering it.', timerMinutes: null },
    ],
    notes: 'Suitable from 6 months for baby-led weaning. Always stay with your baby while they eat and make sure they are sitting upright. No sugar, no honey (never under 12 months) — ripe banana does all the sweetening. Freeze the fingers in a single layer for up to 3 months.',

    communityRating: 4.8,
    communityRatingCount: 74,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Carrot and Swede Baby Mash (6+ Months)',
    description: 'A classic British root-veg mash for weaning — sweet carrot and mellow swede steamed until soft, then mashed with a knob of unsalted butter. Suitable from 6 months. Safety note: no added salt, check the temperature before serving, and never give honey under 12 months.',
    images: [],
    sourceUrl: '',
    servings: 5,
    prepTime: 10,
    cookTime: 20,
    totalTime: 30,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Baby Food'],
    tags: ['gluten-free', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'vegetarian', 'under-30-min', 'freezer-friendly', 'batch-cooking', 'budget-friendly', '5-ingredients-or-less'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 40, protein: 0.6, carbs: 7, fat: 1.2, fiber: 2, sugar: 4, sodium: 15, iron: 0.3,
    },

    ingredients: [
      { qty: 2, unit: 'medium', item: 'carrots, peeled and sliced', group: 'Main' },
      { qty: 200, unit: 'g', item: 'swede, peeled and cubed', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'unsalted butter', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Peel the carrots and swede and cut into even 2 cm pieces.', timerMinutes: null },
      { order: 2, instruction: 'Steam until both vegetables are completely tender.', timerMinutes: 18 },
      { order: 3, instruction: 'Mash with the unsalted butter — smooth for first tastes, or with soft lumps from around 7 months. Add a splash of the steaming water or your baby\'s usual milk to loosen if needed.', timerMinutes: null },
      { order: 4, instruction: 'Cool to lukewarm, test on the inside of your wrist and serve.', timerMinutes: null },
    ],
    notes: 'Suitable from 6 months. Use unsalted butter only and add no salt. Steamed batons of the same veg make a good soft finger food alongside the mash for baby-led weaners — check they squash easily between your fingers. Freezes well for up to 3 months.',

    communityRating: 4.5,
    communityRatingCount: 36,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Salmon and Sweet Potato Baby Mash (7+ Months)',
    description: 'An omega-3 rich mash of flaked poached salmon and sweet potato for babies from around 7 months — oily fish supports brain development and this is a gentle way to introduce it. Safety note: check very carefully for bones, add no salt, and never give honey under 12 months.',
    images: [],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 20,
    totalTime: 30,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Baby Food'],
    tags: ['gluten-free', 'dairy-free', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'high-protein', 'under-30-min', 'freezer-friendly', 'pescatarian'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 85, protein: 6, carbs: 9, fat: 2.8, fiber: 1.5, sugar: 3, sodium: 25, iron: 0.5,
    },

    ingredients: [
      { qty: 1, unit: 'small', item: 'skinless, boneless salmon fillet (about 100 g)', group: 'Main' },
      { qty: 1, unit: 'medium', item: 'sweet potato, peeled and cubed', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'baby\'s usual milk or water', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Steam the sweet potato cubes until completely tender.', timerMinutes: 12 },
      { order: 2, instruction: 'Meanwhile, place the salmon in a small pan, cover with water and poach gently until it flakes easily and is cooked through.', timerMinutes: 8 },
      { order: 3, instruction: 'Flake the salmon with a fork, checking meticulously for any bones — run your fingers through every flake.', timerMinutes: null },
      { order: 4, instruction: 'Mash the sweet potato with the milk or water, then stir through the flaked salmon. Blend for a smoother texture for younger babies.', timerMinutes: null },
      { order: 5, instruction: 'Cool to lukewarm, test the temperature and serve.', timerMinutes: null },
    ],
    notes: 'Suitable from around 7 months, once first vegetables are established. The NHS recommends oily fish for babies but no more than two portions a week for girls. Double-check for bones every time. No added salt. Freeze portions for up to 1 month for best flavour.',

    communityRating: 4.7,
    communityRatingCount: 45,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Soft Broccoli Trees (Baby-Led Weaning, 6+ Months)',
    description: 'Steamed broccoli florets with long stalks — nature\'s perfect handle for little hands learning to self-feed from 6 months. Cooked soft enough to squash between your fingers. Safety note: always supervise, sit baby upright in a highchair, and steam until genuinely soft — firm veg is a choking risk.',
    images: [],
    sourceUrl: '',
    servings: 2,
    prepTime: 5,
    cookTime: 10,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Baby Food', 'Sides'],
    tags: ['gluten-free', 'dairy-free', 'vegan', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'under-15-min', '5-ingredients-or-less', 'budget-friendly'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 20, protein: 2, carbs: 3, fat: 0.3, fiber: 2, sugar: 1, sodium: 15, iron: 0.5,
    },

    ingredients: [
      { qty: 6, unit: 'large', item: 'broccoli florets with 4-5 cm of stalk left on', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Cut the broccoli into large florets, keeping a good length of stalk on each one to act as a handle.', timerMinutes: null },
      { order: 2, instruction: 'Steam until very soft — the stalk should squash easily between your thumb and forefinger. Softer than you would cook it for adults.', timerMinutes: 9 },
      { order: 3, instruction: 'Cool to lukewarm and hand a floret to your baby stalk-first, or rest it on their tray and let them explore.', timerMinutes: null },
    ],
    notes: 'Suitable from 6 months. Gagging is normal while babies learn — choking is silent, so always stay within arm\'s reach and never lean baby back while eating. No salt, no sauces needed. Expect glorious mess: that is how babies learn to eat.',

    communityRating: 4.6,
    communityRatingCount: 39,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Chickpea and Red Pepper Baby Mash (7+ Months)',
    description: 'An iron-boosting mash of chickpeas, sweet red pepper and a hint of mild cumin for babies from around 7 months. Plant iron matters once milk alone is no longer enough. Safety note: blend chickpeas well — whole ones are a choking risk for young babies — and never add honey under 12 months.',
    images: [],
    sourceUrl: '',
    servings: 4,
    prepTime: 5,
    cookTime: 10,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Mediterranean',
    region: 'Mediterranean',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Baby Food'],
    tags: ['gluten-free', 'dairy-free', 'vegan', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'high-iron', 'high-fiber', 'under-15-min', 'freezer-friendly', 'budget-friendly'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 70, protein: 3.5, carbs: 10, fat: 1.5, fiber: 3, sugar: 2, sodium: 20, iron: 1.2,
    },

    ingredients: [
      { qty: 200, unit: 'g', item: 'tinned chickpeas in water (no added salt), drained and rinsed', group: 'Main' },
      { qty: 0.5, unit: 'large', item: 'red pepper, deseeded and chopped', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'olive oil', group: 'Main' },
      { qty: 1, unit: 'pinch', item: 'ground cumin', group: 'Seasoning' },
      { qty: 4, unit: 'tbsp', item: 'water', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Soften the chopped red pepper in the olive oil over a low heat until completely tender.', timerMinutes: 6 },
      { order: 2, instruction: 'Add the rinsed chickpeas, cumin and water and warm through.', timerMinutes: 3 },
      { order: 3, instruction: 'Blend to a smooth, hummus-like puree, adding extra water as needed. For older babies, leave it slightly coarser — but never serve whole chickpeas to babies.', timerMinutes: null },
      { order: 4, instruction: 'Cool to lukewarm and serve on a spoon, or spread on soft toast fingers for baby-led weaners.', timerMinutes: null },
    ],
    notes: 'Suitable from around 7 months. Choose tinned pulses with no added salt. Pair with vitamin C-rich foods like pepper (already in here!) to help iron absorption. Freeze in cubes for up to 3 months. Never honey under 12 months.',

    communityRating: 4.5,
    communityRatingCount: 31,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },

  // ============================================================
  // TODDLER (1-3 years) — 8 recipes
  // Minimal salt, no added sugar where possible, safe textures:
  // grapes and cherry tomatoes always quartered lengthways,
  // no whole nuts, eggs always fully cooked.
  // ============================================================
  {
    title: 'Hidden Veg Pasta Sauce',
    description: 'A silky tomato sauce with five vegetables blitzed invisibly smooth — the batch-cooking hero for toddlers who claim to hate anything green. Stir through pasta, spread on pizza bases or spoon over fish fingers. Freezes brilliantly in toddler-sized portions.',
    images: [],
    sourceUrl: '',
    servings: 8,
    prepTime: 10,
    cookTime: 30,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Italian',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Sauces & Dips'],
    tags: ['vegetarian', 'vegan', 'gluten-free', 'dairy-free', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'freezer-friendly', 'batch-cooking', 'budget-friendly', 'family-friendly'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 55, protein: 1.5, carbs: 8, fat: 2, fiber: 2.5, sugar: 5, sodium: 30, iron: 0.7,
    },

    ingredients: [
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Main' },
      { qty: 1, unit: 'medium', item: 'onion, chopped', group: 'Main' },
      { qty: 1, unit: 'medium', item: 'carrot, grated', group: 'Main' },
      { qty: 1, unit: 'small', item: 'courgette, grated', group: 'Main' },
      { qty: 1, unit: 'small', item: 'red pepper, chopped', group: 'Main' },
      { qty: 2, unit: 'cloves', item: 'garlic, crushed', group: 'Main' },
      { qty: 2, unit: 'tins (400 g)', item: 'chopped tomatoes', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Seasoning' },
      { qty: 100, unit: 'ml', item: 'water', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Warm the oil in a large pan and soften the onion, carrot, courgette and pepper over a medium-low heat without browning.', timerMinutes: 8 },
      { order: 2, instruction: 'Stir in the garlic and oregano and cook for another minute.', timerMinutes: 1 },
      { order: 3, instruction: 'Add the chopped tomatoes and water, then simmer gently until the vegetables are completely soft and the sauce has thickened.', timerMinutes: 20 },
      { order: 4, instruction: 'Blend until completely smooth — no tell-tale lumps.', timerMinutes: null },
      { order: 5, instruction: 'Stir through cooked pasta, cool the rest and freeze flat in small bags or an ice cube tray for instant toddler dinners.', timerMinutes: null },
    ],
    notes: 'No added salt or sugar — the veg makes it naturally sweet. Adults can season their own portion at the table. Keeps 3 days in the fridge or 3 months in the freezer. Suitable from weaning onwards too — it is smooth enough for babies from 6 months.',

    communityRating: 4.8,
    communityRatingCount: 88,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Mini Salmon and Pea Fishcakes',
    description: 'Little golden fishcakes sized for toddler hands, made with tinned salmon, mashed potato and sweet peas. Baked, not fried, and made without added salt — a sneaky portion of oily fish that most toddlers demolish. Great warm or cold in a lunchbox.',
    images: [],
    sourceUrl: '',
    servings: 10,
    prepTime: 20,
    cookTime: 20,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Lunch', 'Dinner'],
    tags: ['nut-free', 'sugar-free', 'low-sodium', 'high-protein', 'pescatarian', 'freezer-friendly', 'batch-cooking', 'lunchbox', 'family-friendly'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 80, protein: 6, carbs: 8, fat: 2.5, fiber: 1.2, sugar: 0.8, sodium: 60, iron: 0.5,
    },

    ingredients: [
      { qty: 300, unit: 'g', item: 'potatoes, peeled and cubed', group: 'Fishcakes' },
      { qty: 1, unit: 'tin (213 g)', item: 'red salmon, drained, skin and bones removed', group: 'Fishcakes' },
      { qty: 75, unit: 'g', item: 'frozen peas, defrosted and lightly crushed', group: 'Fishcakes' },
      { qty: 1, unit: 'tbsp', item: 'chopped fresh dill or chives (optional)', group: 'Fishcakes' },
      { qty: 1, unit: 'large', item: 'egg, beaten', group: 'Coating' },
      { qty: 50, unit: 'g', item: 'breadcrumbs', group: 'Coating' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Coating' },
    ],
    steps: [
      { order: 1, instruction: 'Boil the potatoes until tender, drain well and mash without butter or salt. Leave to cool slightly.', timerMinutes: 12 },
      { order: 2, instruction: 'Flake the salmon into the mash, checking carefully that every trace of skin and bone is removed. Fold in the crushed peas and herbs.', timerMinutes: null },
      { order: 3, instruction: 'Shape into 10 small patties about 2 cm thick — palm-sized for a toddler.', timerMinutes: null },
      { order: 4, instruction: 'Dip each patty in beaten egg, then coat in breadcrumbs. Place on a lined baking tray and drizzle or brush with olive oil.', timerMinutes: null },
      { order: 5, instruction: 'Bake at 200°C fan, turning halfway, until golden and piping hot in the middle. Cool to warm before serving to little ones.', timerMinutes: 20 },
    ],
    notes: 'Tinned salmon is a budget-friendly oily fish; its soft bones must still be picked out for small children. The egg is fully cooked during baking, so no British Lion caveat needed. Freeze uncooked, layered with baking paper, for up to 2 months — bake from frozen with 5 extra minutes.',

    communityRating: 4.7,
    communityRatingCount: 66,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Broccoli and Cheddar Toddler Muffins',
    description: 'Savoury little muffins packed with broccoli and mature cheddar — a lunchbox and buggy-snack staple for 1-3 year olds. One bowl, no added sugar and only the salt that comes in the cheese. They freeze and defrost in minutes.',
    images: [],
    sourceUrl: '',
    servings: 12,
    prepTime: 15,
    cookTime: 18,
    totalTime: 33,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Snacks', 'Baking'],
    tags: ['vegetarian', 'nut-free', 'sugar-free', 'under-30-min', 'freezer-friendly', 'batch-cooking', 'lunchbox', 'family-friendly', 'budget-friendly'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 95, protein: 4, carbs: 10, fat: 4.5, fiber: 0.8, sugar: 1, sodium: 115, iron: 0.5,
    },

    ingredients: [
      { qty: 150, unit: 'g', item: 'self-raising flour', group: 'Muffins' },
      { qty: 100, unit: 'g', item: 'broccoli, cut into tiny florets and steamed soft', group: 'Muffins' },
      { qty: 80, unit: 'g', item: 'mature cheddar, grated', group: 'Muffins' },
      { qty: 2, unit: 'large', item: 'eggs', group: 'Muffins' },
      { qty: 120, unit: 'ml', item: 'whole milk', group: 'Muffins' },
      { qty: 3, unit: 'tbsp', item: 'olive oil', group: 'Muffins' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat the oven to 180°C fan and line a 12-hole mini muffin tin with cases or a little oil.', timerMinutes: null },
      { order: 2, instruction: 'Steam the tiny broccoli florets until soft, then chop finely.', timerMinutes: 6 },
      { order: 3, instruction: 'Whisk the eggs, milk and oil in a bowl, then fold in the flour, broccoli and most of the cheese until just combined.', timerMinutes: null },
      { order: 4, instruction: 'Spoon into the tin, top with the remaining cheese and bake until risen, golden and a skewer comes out clean.', timerMinutes: 18 },
      { order: 5, instruction: 'Cool on a rack — serve just warm or cold. Cut in half for younger toddlers.', timerMinutes: null },
    ],
    notes: 'No added salt beyond the cheddar, and no sugar. Eggs are fully cooked through baking. Swap broccoli for grated courgette (squeezed dry) or sweetcorn for variety. Freeze for up to 2 months; defrost at room temperature in about an hour.',

    communityRating: 4.6,
    communityRatingCount: 52,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Creamy Chicken and Sweetcorn Pasta for Little Ones',
    description: 'Soft pasta shells in a gentle cream cheese sauce with shredded chicken and sweetcorn — a 20-minute toddler dinner that parents end up stealing. Mild, low-salt and easily mashed with the back of a fork for younger eaters.',
    images: [],
    sourceUrl: '',
    servings: 4,
    prepTime: 5,
    cookTime: 15,
    totalTime: 20,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Dinner'],
    tags: ['nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'high-protein', 'under-30-min', 'family-friendly', 'weeknight-dinner', 'budget-friendly'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 260, protein: 17, carbs: 32, fat: 7, fiber: 2.5, sugar: 3, sodium: 95, iron: 1.2,
    },

    ingredients: [
      { qty: 200, unit: 'g', item: 'small pasta shells', group: 'Main' },
      { qty: 1, unit: 'small', item: 'cooked chicken breast, finely shredded', group: 'Main' },
      { qty: 150, unit: 'g', item: 'frozen sweetcorn', group: 'Main' },
      { qty: 100, unit: 'g', item: 'full-fat soft cheese', group: 'Sauce' },
      { qty: 75, unit: 'ml', item: 'whole milk', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'grated parmesan', group: 'Sauce' },
      { qty: 1, unit: 'pinch', item: 'black pepper', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Cook the pasta in unsalted boiling water until soft — a minute or two past al dente for toddlers. Add the sweetcorn for the last 3 minutes.', timerMinutes: 12 },
      { order: 2, instruction: 'Drain, keeping a mugful of the cooking water.', timerMinutes: null },
      { order: 3, instruction: 'Return the pan to a low heat and melt the soft cheese with the milk, stirring into a smooth sauce.', timerMinutes: 2 },
      { order: 4, instruction: 'Stir in the pasta, sweetcorn, shredded chicken and parmesan, loosening with splashes of cooking water until glossy. Warm the chicken right through.', timerMinutes: 2 },
      { order: 5, instruction: 'Cool to warm before serving. Chop or lightly mash for younger toddlers.', timerMinutes: null },
    ],
    notes: 'Make sure reheated or pre-cooked chicken is piping hot, then cooled to a safe eating temperature. Parents: season your own bowls at the table with salt, pepper and a squeeze of lemon rather than salting the pot. Add frozen peas or shredded spinach with the sweetcorn for extra veg.',

    communityRating: 4.7,
    communityRatingCount: 71,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Cheesy Bean Quesadilla Triangles',
    description: 'Toasted tortilla triangles filled with mashed beans, melted cheese and mild veg — brilliant finger food for toddlers from 12 months, and a 10-minute lunch the whole family can share. No added salt, no chilli, all the melty appeal.',
    images: [],
    sourceUrl: '',
    servings: 4,
    prepTime: 5,
    cookTime: 10,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Mexican',
    region: 'Americas',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Lunch', 'Snacks'],
    tags: ['vegetarian', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'high-fiber', 'under-15-min', 'lunchbox', 'family-friendly', 'budget-friendly', 'pantry-staples'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 210, protein: 9, carbs: 26, fat: 8, fiber: 4, sugar: 2, sodium: 220, iron: 1.4,
    },

    ingredients: [
      { qty: 4, unit: 'small', item: 'soft flour tortillas', group: 'Main' },
      { qty: 200, unit: 'g', item: 'tinned black beans or kidney beans (no added salt), drained', group: 'Filling' },
      { qty: 80, unit: 'g', item: 'mild cheddar, grated', group: 'Filling' },
      { qty: 0.5, unit: 'small', item: 'red pepper, very finely diced', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'mild smoked paprika', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'olive oil', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Mash the drained beans roughly with the paprika — a few whole beans are fine for toddlers over 12 months, but mash well for younger ones.', timerMinutes: null },
      { order: 2, instruction: 'Spread the bean mash over two tortillas, scatter with cheese and diced pepper, and top with the remaining tortillas.', timerMinutes: null },
      { order: 3, instruction: 'Brush a frying pan with the oil and toast each quesadilla over a medium heat until golden and the cheese has melted, pressing gently with a spatula.', timerMinutes: 6 },
      { order: 4, instruction: 'Cool for a couple of minutes — melted cheese holds heat — then cut into small triangles and check the temperature before handing over.', timerMinutes: null },
    ],
    notes: 'Choose tinned beans with no added salt and, if you can, lower-salt tortillas — wraps are one of the saltiest items in a toddler diet, so keep portions sensible. If serving cherry tomatoes or grapes alongside, always quarter them lengthways.',

    communityRating: 4.6,
    communityRatingCount: 47,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Banana and Blueberry Oat Bars (No Added Sugar)',
    description: 'Soft-baked breakfast bars sweetened only with banana and bursts of blueberry — no refined sugar, no syrup, no nuts. Perfect for toddler breakfasts on busy mornings, and squidgy enough for little mouths from 12 months.',
    images: [],
    sourceUrl: '',
    servings: 12,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Breakfast', 'Snacks'],
    tags: ['vegetarian', 'nut-free', 'sugar-free', 'low-sodium', 'high-fiber', 'freezer-friendly', 'batch-cooking', 'make-ahead', 'lunchbox', 'budget-friendly'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 90, protein: 2.5, carbs: 14, fat: 2.8, fiber: 1.8, sugar: 4, sodium: 12, iron: 0.6,
    },

    ingredients: [
      { qty: 2, unit: 'large', item: 'ripe bananas, mashed', group: 'Main' },
      { qty: 200, unit: 'g', item: 'porridge oats', group: 'Main' },
      { qty: 1, unit: 'large', item: 'egg, beaten', group: 'Main' },
      { qty: 100, unit: 'ml', item: 'whole milk', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'olive oil or melted unsalted butter', group: 'Main' },
      { qty: 100, unit: 'g', item: 'blueberries, halved', group: 'Main' },
      { qty: 0.5, unit: 'tsp', item: 'ground cinnamon', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat the oven to 180°C fan and line a 20 cm square tin with baking paper.', timerMinutes: null },
      { order: 2, instruction: 'Mash the bananas, then stir in the egg, milk, oil and cinnamon.', timerMinutes: null },
      { order: 3, instruction: 'Fold in the oats and halved blueberries.', timerMinutes: null },
      { order: 4, instruction: 'Press into the tin and bake until set and golden at the edges.', timerMinutes: 25 },
      { order: 5, instruction: 'Cool completely in the tin before cutting into 12 soft bars.', timerMinutes: null },
    ],
    notes: 'Halve blueberries for toddlers — like grapes, whole round fruits should be cut for under-5s (quarter grapes lengthways, always). The egg is fully baked. No honey needed; if you ever do add it for over-1s, remember honey is never safe under 12 months. Freezes for 2 months.',

    communityRating: 4.7,
    communityRatingCount: 59,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Rainbow Omelette Strips',
    description: 'A soft, fully-cooked omelette laced with grated veg and cheese, rolled and sliced into colourful strips toddlers can pick up themselves. Five minutes from fridge to highchair tray, and a great way to use up odds and ends of veg.',
    images: [],
    sourceUrl: '',
    servings: 2,
    prepTime: 5,
    cookTime: 6,
    totalTime: 11,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Breakfast', 'Lunch'],
    tags: ['vegetarian', 'gluten-free', 'nut-free', 'sugar-free', 'low-sodium', 'high-protein', 'under-15-min', '5-ingredients-or-less', 'budget-friendly'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 130, protein: 9, carbs: 3, fat: 9, fiber: 0.8, sugar: 2, sodium: 140, iron: 1.1,
    },

    ingredients: [
      { qty: 2, unit: 'large', item: 'eggs', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'grated carrot', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'grated courgette, squeezed dry', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'grated mild cheddar', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'unsalted butter or olive oil', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Beat the eggs with the grated carrot, courgette and cheese.', timerMinutes: null },
      { order: 2, instruction: 'Melt the butter in a small non-stick pan over a medium-low heat and pour in the egg mixture, tilting to coat the base.', timerMinutes: null },
      { order: 3, instruction: 'Cook gently until completely set on top with no runny egg — flip for the final minute to be sure it is cooked through.', timerMinutes: 5 },
      { order: 4, instruction: 'Slide onto a board, cool to warm, roll into a cigar and slice into strips.', timerMinutes: null },
    ],
    notes: 'Eggs for toddlers should always be cooked until firm unless they carry the British Lion stamp (and even then, fully cooked is the easy default for this recipe). No added salt — the cheddar carries the flavour. Add finely chopped spinach or sweetcorn for extra colours in the rainbow.',

    communityRating: 4.5,
    communityRatingCount: 44,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Baked Fish Goujons with Mushy Peas',
    description: 'Homemade fish fingers — strips of white fish in golden breadcrumbs, baked not fried — with soft, minty crushed peas. A toddler classic done the low-salt way, and honestly better than the freezer-aisle version for the whole family.',
    images: [],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 15,
    totalTime: 30,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby & Toddler', 'Dinner'],
    tags: ['nut-free', 'sugar-free', 'low-sodium', 'high-protein', 'pescatarian', 'under-30-min', 'freezer-friendly', 'family-friendly', 'weeknight-dinner'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 220, protein: 20, carbs: 20, fat: 6, fiber: 3, sugar: 2, sodium: 180, iron: 1.0,
    },

    ingredients: [
      { qty: 400, unit: 'g', item: 'skinless, boneless cod or haddock fillet', group: 'Goujons' },
      { qty: 60, unit: 'g', item: 'breadcrumbs', group: 'Goujons' },
      { qty: 2, unit: 'tbsp', item: 'plain flour', group: 'Goujons' },
      { qty: 1, unit: 'large', item: 'egg, beaten', group: 'Goujons' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Goujons' },
      { qty: 300, unit: 'g', item: 'frozen peas', group: 'Peas' },
      { qty: 1, unit: 'tsp', item: 'unsalted butter', group: 'Peas' },
      { qty: 2, unit: 'leaves', item: 'fresh mint (optional)', group: 'Peas' },
      { qty: 1, unit: 'squeeze', item: 'lemon juice', group: 'Peas' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat the oven to 200°C fan and line a baking tray. Cut the fish into finger-width strips, running your fingers over each one to check for stray bones.', timerMinutes: null },
      { order: 2, instruction: 'Set up three dishes: flour, beaten egg, and breadcrumbs. Coat each strip in flour, then egg, then breadcrumbs.', timerMinutes: null },
      { order: 3, instruction: 'Space the goujons on the tray, drizzle with olive oil and bake until golden and cooked through — the fish should flake easily.', timerMinutes: 14 },
      { order: 4, instruction: 'Meanwhile, boil the peas until tender, drain, and crush roughly with the butter, mint and lemon juice.', timerMinutes: 4 },
      { order: 5, instruction: 'Cool the goujons briefly and check for any bones once more before serving with the crushed peas.', timerMinutes: null },
    ],
    notes: 'No added salt in the crumb — adults can add salt, tartare sauce or vinegar at the table. The egg coating is fully baked. Freeze the goujons uncooked for up to 2 months and bake from frozen with 5 extra minutes, making sure they are piping hot throughout.',

    communityRating: 4.8,
    communityRatingCount: 79,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },

  // ============================================================
  // FAMILY ONE-POT / TRAY MEALS — 8 recipes
  // "Cook once, feed everyone": each written unsalted-first with a
  // "For baby (from X months)" adaptation, so one pan feeds
  // adults, toddlers and the baby.
  // ============================================================
  {
    title: 'One-Pot Chicken and Vegetable Orzo',
    description: 'Cook once, feed everyone: tender chicken thighs, orzo and soft vegetables simmered in one pan into a gentle, risotto-like supper. Built unsalted so every age at the table can eat it. For baby (from 7 months): take out a portion before adding parmesan, then chop or mash to suit their stage.',
    images: [],
    sourceUrl: '',
    servings: 5,
    prepTime: 10,
    cookTime: 30,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Italian',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Family Meals', 'Dinner'],
    tags: ['one-pot', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'high-protein', 'family-friendly', 'weeknight-dinner', 'budget-friendly', 'comfort-food'],
    ageGroups: ['baby', 'toddler', 'kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 420, protein: 30, carbs: 45, fat: 13, fiber: 3.5, sugar: 4, sodium: 210, iron: 2.2,
    },

    ingredients: [
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Main' },
      { qty: 6, unit: 'boneless, skinless', item: 'chicken thighs, chopped', group: 'Main' },
      { qty: 1, unit: 'medium', item: 'onion, finely chopped', group: 'Main' },
      { qty: 2, unit: 'medium', item: 'carrots, finely diced', group: 'Main' },
      { qty: 1, unit: 'small', item: 'courgette, diced', group: 'Main' },
      { qty: 2, unit: 'cloves', item: 'garlic, crushed', group: 'Main' },
      { qty: 300, unit: 'g', item: 'orzo pasta', group: 'Main' },
      { qty: 900, unit: 'ml', item: 'low-salt chicken stock', group: 'Main' },
      { qty: 100, unit: 'g', item: 'frozen peas', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Seasoning' },
      { qty: 40, unit: 'g', item: 'parmesan, grated (to finish, adults and toddlers)', group: 'To Serve' },
      { qty: 1, unit: 'squeeze', item: 'lemon juice (to finish)', group: 'To Serve' },
    ],
    steps: [
      { order: 1, instruction: 'Heat the oil in a large casserole and brown the chopped chicken thighs over a medium-high heat.', timerMinutes: 5 },
      { order: 2, instruction: 'Add the onion, carrot and courgette and soften.', timerMinutes: 6 },
      { order: 3, instruction: 'Stir in the garlic, oregano and orzo, then pour in the low-salt stock.', timerMinutes: null },
      { order: 4, instruction: 'Simmer, stirring now and then so the orzo does not stick, until the pasta is tender and the liquid mostly absorbed. Add the peas for the final 3 minutes.', timerMinutes: 14 },
      { order: 5, instruction: 'For baby (from 7 months): scoop out their portion now, before the cheese, and chop or mash to the texture they manage. Check for and remove any large chicken pieces they cannot chew.', timerMinutes: null },
      { order: 6, instruction: 'Stir the parmesan and lemon juice through the rest. Adults season at the table — never the pot.', timerMinutes: null },
    ],
    notes: 'Cook once, feed everyone. Use low-salt or homemade stock — regular cubes push a baby past their daily sodium in one bowl. Baby portions freeze well in cubes; family leftovers keep 2 days in the fridge, reheated until piping hot.',

    communityRating: 4.8,
    communityRatingCount: 93,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Cottage Pie with Hidden Veg',
    description: 'Cook once, feed everyone: the great British comfort classic with lentils and finely diced veg folded into the beef, under a cloud of mash. Made without added salt so it suits the smallest diner too. For baby (from 7 months): mash their portion with a fork — the soft texture is weaning gold.',
    images: [],
    sourceUrl: '',
    servings: 6,
    prepTime: 20,
    cookTime: 55,
    totalTime: 75,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Family Meals', 'Dinner'],
    tags: ['nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'high-protein', 'high-iron', 'freezer-friendly', 'batch-cooking', 'make-ahead', 'family-friendly', 'comfort-food', 'sunday-dinner'],
    ageGroups: ['baby', 'toddler', 'kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 380, protein: 24, carbs: 38, fat: 14, fiber: 5, sugar: 6, sodium: 160, iron: 3.5,
    },

    ingredients: [
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Filling' },
      { qty: 500, unit: 'g', item: 'lean beef mince', group: 'Filling' },
      { qty: 1, unit: 'large', item: 'onion, finely chopped', group: 'Filling' },
      { qty: 2, unit: 'medium', item: 'carrots, finely diced', group: 'Filling' },
      { qty: 2, unit: 'sticks', item: 'celery, finely diced', group: 'Filling' },
      { qty: 100, unit: 'g', item: 'red lentils, rinsed', group: 'Filling' },
      { qty: 2, unit: 'tbsp', item: 'tomato puree', group: 'Filling' },
      { qty: 500, unit: 'ml', item: 'low-salt beef stock', group: 'Filling' },
      { qty: 1, unit: 'tsp', item: 'dried thyme', group: 'Seasoning' },
      { qty: 1, unit: 'kg', item: 'potatoes, peeled and chunked', group: 'Topping' },
      { qty: 30, unit: 'g', item: 'unsalted butter', group: 'Topping' },
      { qty: 75, unit: 'ml', item: 'whole milk', group: 'Topping' },
      { qty: 40, unit: 'g', item: 'mature cheddar, grated (optional)', group: 'Topping' },
    ],
    steps: [
      { order: 1, instruction: 'Heat the oil in a wide pan and brown the mince, breaking it up as you go.', timerMinutes: 6 },
      { order: 2, instruction: 'Add the onion, carrot and celery and cook until soft — dice them small enough to vanish.', timerMinutes: 8 },
      { order: 3, instruction: 'Stir in the tomato puree, thyme, lentils and stock. Simmer gently until the lentils are soft and the sauce is thick.', timerMinutes: 25 },
      { order: 4, instruction: 'Meanwhile, boil the potatoes until tender, then mash with the butter and milk.', timerMinutes: 15 },
      { order: 5, instruction: 'Spoon the filling into a baking dish, top with mash, rough up the surface with a fork and scatter with cheese if using. Bake at 200°C fan until golden.', timerMinutes: 25 },
      { order: 6, instruction: 'For baby (from 7 months): mash a cooled portion with a fork — filling and potato together. For toddlers, serve as is. Adults add salt, pepper and Worcestershire-style sauce at the table.', timerMinutes: null },
    ],
    notes: 'Cook once, feed everyone. The lentils stretch the beef, boost fibre and iron, and soften the texture for little mouths. Assembles a day ahead, and freezes whole or in portions for 3 months — reheat until piping hot right through.',

    communityRating: 4.9,
    communityRatingCount: 112,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Tray-Baked Salmon with New Potatoes and Greens',
    description: 'Cook once, feed everyone: one tray of salmon fillets, baby new potatoes and tender-stem broccoli with a lemony olive-oil dressing. On the table in 35 minutes with almost no washing up. For baby (from 7 months): flake a little salmon (check for bones) and crush a potato and some broccoli with it.',
    images: [],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 30,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Family Meals', 'Dinner'],
    tags: ['sheet-pan', 'one-pan', 'gluten-free', 'dairy-free', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'high-protein', 'pescatarian', 'family-friendly', 'weeknight-dinner'],
    ageGroups: ['baby', 'toddler', 'kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 430, protein: 30, carbs: 32, fat: 20, fiber: 4, sugar: 3, sodium: 140, iron: 1.8,
    },

    ingredients: [
      { qty: 4, unit: 'skinless', item: 'salmon fillets', group: 'Main' },
      { qty: 600, unit: 'g', item: 'baby new potatoes, halved', group: 'Main' },
      { qty: 200, unit: 'g', item: 'tender-stem broccoli', group: 'Main' },
      { qty: 150, unit: 'g', item: 'cherry tomatoes', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'olive oil', group: 'Dressing' },
      { qty: 1, unit: 'whole', item: 'lemon — zest and juice', group: 'Dressing' },
      { qty: 2, unit: 'cloves', item: 'garlic, crushed', group: 'Dressing' },
      { qty: 1, unit: 'tbsp', item: 'chopped fresh dill or parsley', group: 'Dressing' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat the oven to 200°C fan. Toss the halved potatoes with 2 tablespoons of the oil on a large tray and roast until nearly tender.', timerMinutes: 18 },
      { order: 2, instruction: 'Nestle in the salmon, broccoli and cherry tomatoes. Mix the remaining oil with the lemon zest, juice and garlic and spoon over everything.', timerMinutes: null },
      { order: 3, instruction: 'Return to the oven until the salmon is just cooked through and flakes easily.', timerMinutes: 12 },
      { order: 4, instruction: 'For baby (from 7 months): flake a small piece of salmon, triple-checking for bones, and crush together with a potato and a soft broccoli floret. Halve or quarter any cherry tomato you give a small child — always.', timerMinutes: null },
      { order: 5, instruction: 'Scatter the herbs over the tray. Adults finish with salt, pepper and extra lemon at the table.', timerMinutes: null },
    ],
    notes: 'Cook once, feed everyone. Oily fish once or twice a week is an NHS recommendation for all ages. No salt is added during cooking so the tray is safe for babies and toddlers — grown-ups season their own plates.',

    communityRating: 4.7,
    communityRatingCount: 84,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Gentle Chicken and Coconut Curry',
    description: 'Cook once, feed everyone: a mild, creamy coconut curry with chicken, sweet potato and spinach — all the warmth of the spice tin with none of the heat, so it works for the baby, the toddler and the grown-ups (who get a chilli-oil upgrade at the table). For baby (from 7 months): blend or mash their portion with extra rice.',
    images: [],
    sourceUrl: '',
    servings: 5,
    prepTime: 15,
    cookTime: 30,
    totalTime: 45,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'United Kingdom',

    categories: ['Family Meals', 'Dinner'],
    tags: ['one-pot', 'gluten-free', 'dairy-free', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'high-protein', 'family-friendly', 'weeknight-dinner', 'freezer-friendly', 'comfort-food'],
    ageGroups: ['baby', 'toddler', 'kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 410, protein: 28, carbs: 22, fat: 24, fiber: 4, sugar: 7, sodium: 150, iron: 2.5,
    },

    ingredients: [
      { qty: 1, unit: 'tbsp', item: 'coconut or vegetable oil', group: 'Main' },
      { qty: 500, unit: 'g', item: 'chicken thigh fillets, chopped', group: 'Main' },
      { qty: 1, unit: 'large', item: 'onion, finely chopped', group: 'Main' },
      { qty: 2, unit: 'cloves', item: 'garlic, crushed', group: 'Main' },
      { qty: 1, unit: 'thumb', item: 'fresh ginger, grated', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'ground turmeric', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'ground coriander', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'mild garam masala', group: 'Spices' },
      { qty: 1, unit: 'medium', item: 'sweet potato, peeled and diced', group: 'Main' },
      { qty: 1, unit: 'tin (400 ml)', item: 'coconut milk', group: 'Main' },
      { qty: 100, unit: 'ml', item: 'water', group: 'Main' },
      { qty: 100, unit: 'g', item: 'baby spinach', group: 'Main' },
      { qty: 1, unit: 'squeeze', item: 'lime juice', group: 'To Serve' },
    ],
    steps: [
      { order: 1, instruction: 'Heat the oil in a large pan and brown the chicken pieces.', timerMinutes: 5 },
      { order: 2, instruction: 'Add the onion and soften, then stir in the garlic, ginger and ground spices for a fragrant minute.', timerMinutes: 6 },
      { order: 3, instruction: 'Add the sweet potato, coconut milk and water. Simmer gently until the sweet potato is tender and the chicken cooked through.', timerMinutes: 18 },
      { order: 4, instruction: 'Stir in the spinach until just wilted, then finish with lime juice.', timerMinutes: 2 },
      { order: 5, instruction: 'For baby (from 7 months): blend or fork-mash a portion with rice to a manageable texture. Mild spices are fine for babies — it is salt and chilli they must avoid.', timerMinutes: null },
      { order: 6, instruction: 'Serve with rice. Adults add salt, fresh chilli or chilli oil at the table.', timerMinutes: null },
    ],
    notes: 'Cook once, feed everyone. Aromatic spices (turmeric, coriander, cinnamon) are encouraged during weaning — they build adventurous eaters. Heat and salt stay on the adults\' side of the table. Freezes for 3 months.',

    communityRating: 4.8,
    communityRatingCount: 97,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Smoky Bean and Vegetable One-Pot',
    description: 'Cook once, feed everyone: a rich tomato pot of mixed beans, peppers and sweetcorn with smoked paprika for depth — zero chilli heat, so the whole table shares one pan. Brilliant with rice, jacket potatoes or wedges. For baby (from 7 months): mash their portion well — whole beans are a choking risk.',
    images: [],
    sourceUrl: '',
    servings: 5,
    prepTime: 10,
    cookTime: 30,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Mexican',
    region: 'Americas',
    country: 'United Kingdom',

    categories: ['Family Meals', 'Dinner'],
    tags: ['one-pot', 'vegetarian', 'vegan', 'gluten-free', 'dairy-free', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'high-fiber', 'high-iron', 'family-friendly', 'budget-friendly', 'freezer-friendly', 'pantry-staples'],
    ageGroups: ['baby', 'toddler', 'kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 260, protein: 12, carbs: 40, fat: 5, fiber: 11, sugar: 9, sodium: 120, iron: 3.8,
    },

    ingredients: [
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Main' },
      { qty: 1, unit: 'large', item: 'onion, chopped', group: 'Main' },
      { qty: 1, unit: 'each', item: 'red and yellow pepper, chopped', group: 'Main' },
      { qty: 2, unit: 'cloves', item: 'garlic, crushed', group: 'Main' },
      { qty: 2, unit: 'tsp', item: 'smoked paprika (sweet, not hot)', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Spices' },
      { qty: 2, unit: 'tins (400 g)', item: 'mixed beans in water (no added salt), drained', group: 'Main' },
      { qty: 2, unit: 'tins (400 g)', item: 'chopped tomatoes', group: 'Main' },
      { qty: 150, unit: 'g', item: 'frozen sweetcorn', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Soften the onion and peppers in the oil over a medium heat.', timerMinutes: 8 },
      { order: 2, instruction: 'Stir in the garlic, smoked paprika, cumin and oregano and cook for a minute until fragrant.', timerMinutes: 1 },
      { order: 3, instruction: 'Add the beans, chopped tomatoes and sweetcorn. Simmer until thick and glossy.', timerMinutes: 20 },
      { order: 4, instruction: 'For baby (from 7 months): mash a portion thoroughly — beans must be well squashed for little ones — and serve with soft rice or mashed potato.', timerMinutes: null },
      { order: 5, instruction: 'Serve with rice, jackets or wedges. Adults finish theirs with salt, fresh chilli, hot sauce and coriander; toddlers love a spoon of soured cream and grated cheese.', timerMinutes: null },
    ],
    notes: 'Cook once, feed everyone. Beans and lentils are an NHS-endorsed protein for the whole family and cost pennies. Use no-added-salt tins. Freezes in portions for 3 months — handy as instant toddler lunches.',

    communityRating: 4.6,
    communityRatingCount: 73,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Sausage and Root Veg Autumn Traybake',
    description: 'Cook once, feed everyone: proper sausages roasted over honey-free sticky roots — carrots, parsnips and red onion — with apple wedges that collapse into sweetness. One tin, forty minutes. For baby (from 9 months): offer soft veg sticks and a little well-cooked sausage centre, skin removed.',
    images: [],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 40,
    totalTime: 50,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Family Meals', 'Dinner'],
    tags: ['sheet-pan', 'one-pan', 'nut-free', 'egg-free', 'sugar-free', 'gluten-free', 'dairy-free', 'family-friendly', 'weeknight-dinner', 'budget-friendly', 'comfort-food'],
    ageGroups: ['baby', 'toddler', 'kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 440, protein: 18, carbs: 34, fat: 26, fiber: 7, sugar: 14, sodium: 620, iron: 2.0,
    },

    ingredients: [
      { qty: 8, unit: 'good-quality', item: 'pork sausages (highest meat content you can find)', group: 'Main' },
      { qty: 3, unit: 'medium', item: 'carrots, cut into chunky batons', group: 'Main' },
      { qty: 2, unit: 'medium', item: 'parsnips, cut into chunky batons', group: 'Main' },
      { qty: 1, unit: 'large', item: 'red onion, cut into wedges', group: 'Main' },
      { qty: 1, unit: 'crisp', item: 'eating apple, cored and cut into wedges', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'dried sage or thyme', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat the oven to 190°C fan. Toss the carrots, parsnips and onion with the oil and herbs in a large roasting tin.', timerMinutes: null },
      { order: 2, instruction: 'Lay the sausages on top and roast.', timerMinutes: 20 },
      { order: 3, instruction: 'Turn the sausages, add the apple wedges and roast until everything is golden and the sausages are cooked right through.', timerMinutes: 20 },
      { order: 4, instruction: 'For baby (from 9 months): serve soft carrot and parsnip batons as finger food, plus a little sausage middle — skin peeled off, well cooked, offered sparingly because sausages are salty. Quarter any round slices.', timerMinutes: null },
      { order: 5, instruction: 'Serve with mash or crusty bread and mustard for the grown-ups.', timerMinutes: null },
    ],
    notes: 'Cook once, feed everyone. Sausages carry most of this dish\'s salt, so babies get mostly veg with a taste of sausage — the NHS suggests keeping processed meats occasional for under-2s. No honey glaze on the tray: roasted roots and apple bring the sweetness naturally (and honey is never for under-1s).',

    communityRating: 4.7,
    communityRatingCount: 81,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Tomato and Mascarpone Pasta Bake',
    description: 'Cook once, feed everyone: rigatoni in a creamy, blended tomato and mascarpone sauce (with secretly softened veg), baked under bubbling mozzarella. A crowd-pleaser from nine months to ninety. For baby (from 7 months): set aside a saucy, well-cooked portion before baking and chop the pasta small.',
    images: [],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 40,
    totalTime: 55,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Italian',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Family Meals', 'Dinner'],
    tags: ['vegetarian', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'baking', 'family-friendly', 'make-ahead', 'freezer-friendly', 'comfort-food', 'budget-friendly'],
    ageGroups: ['baby', 'toddler', 'kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 430, protein: 16, carbs: 55, fat: 16, fiber: 4, sugar: 8, sodium: 240, iron: 1.9,
    },

    ingredients: [
      { qty: 450, unit: 'g', item: 'rigatoni or penne', group: 'Main' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Sauce' },
      { qty: 1, unit: 'medium', item: 'onion, chopped', group: 'Sauce' },
      { qty: 1, unit: 'medium', item: 'carrot, grated', group: 'Sauce' },
      { qty: 2, unit: 'cloves', item: 'garlic, crushed', group: 'Sauce' },
      { qty: 2, unit: 'tins (400 g)', item: 'chopped tomatoes', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'dried basil or oregano', group: 'Sauce' },
      { qty: 150, unit: 'g', item: 'mascarpone', group: 'Sauce' },
      { qty: 125, unit: 'g', item: 'mozzarella, torn', group: 'Topping' },
      { qty: 30, unit: 'g', item: 'parmesan, grated', group: 'Topping' },
    ],
    steps: [
      { order: 1, instruction: 'Cook the pasta in unsalted water until just shy of al dente. Drain.', timerMinutes: 10 },
      { order: 2, instruction: 'Meanwhile, soften the onion and carrot in the oil, add the garlic, then the tomatoes and herbs. Simmer until the veg is soft.', timerMinutes: 15 },
      { order: 3, instruction: 'Blend the sauce smooth, then stir in the mascarpone until creamy.', timerMinutes: null },
      { order: 4, instruction: 'For baby (from 7 months): mix a little sauce with some well-cooked pasta, chopped small or mashed, and set aside — babies skip the extra cheese load of the baked top.', timerMinutes: null },
      { order: 5, instruction: 'Toss the rest of the pasta with the sauce in a baking dish, top with mozzarella and parmesan, and bake at 200°C fan until golden and bubbling.', timerMinutes: 20 },
      { order: 6, instruction: 'Rest for 5 minutes before serving — pasta bakes hold ferocious heat. Adults season at the table.', timerMinutes: null },
    ],
    notes: 'Cook once, feed everyone. The blended carrot and onion sweeten the sauce with no added sugar. Assemble ahead and bake when needed, or freeze portions for 3 months. Reheat leftovers until piping hot.',

    communityRating: 4.8,
    communityRatingCount: 105,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
  {
    title: 'Family Beef and Vegetable Stew',
    description: 'Cook once, feed everyone: slow-simmered beef with carrots, swede and potatoes in a rich, unsalted gravy — the one-pot that defines Sunday. Meltingly soft after two hours, which is exactly what small mouths need. For baby (from 7 months): mash their bowl to a coarse, spoonable texture.',
    images: [],
    sourceUrl: '',
    servings: 6,
    prepTime: 20,
    cookTime: 140,
    totalTime: 160,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Family Meals', 'Dinner', 'Soups & Stews'],
    tags: ['one-pot', 'nut-free', 'egg-free', 'dairy-free', 'sugar-free', 'low-sodium', 'high-protein', 'high-iron', 'freezer-friendly', 'batch-cooking', 'make-ahead', 'family-friendly', 'comfort-food', 'sunday-dinner'],
    ageGroups: ['baby', 'toddler', 'kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 350, protein: 28, carbs: 30, fat: 12, fiber: 5, sugar: 6, sodium: 130, iron: 3.9,
    },

    ingredients: [
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Main' },
      { qty: 700, unit: 'g', item: 'braising steak, cut into 3 cm chunks', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'plain flour', group: 'Main' },
      { qty: 1, unit: 'large', item: 'onion, chopped', group: 'Main' },
      { qty: 3, unit: 'medium', item: 'carrots, thickly sliced', group: 'Main' },
      { qty: 300, unit: 'g', item: 'swede, cubed', group: 'Main' },
      { qty: 400, unit: 'g', item: 'potatoes, cubed', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'tomato puree', group: 'Main' },
      { qty: 900, unit: 'ml', item: 'low-salt beef stock', group: 'Main' },
      { qty: 2, unit: 'sprigs', item: 'fresh thyme (or 1 tsp dried)', group: 'Seasoning' },
      { qty: 1, unit: 'whole', item: 'bay leaf', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Toss the beef in the flour. Heat the oil in a large casserole and brown the beef in batches — do not crowd the pan.', timerMinutes: 10 },
      { order: 2, instruction: 'Add the onion and soften, then stir in the tomato puree.', timerMinutes: 5 },
      { order: 3, instruction: 'Return all the beef with the stock, thyme and bay leaf. Cover and simmer very gently.', timerMinutes: 75 },
      { order: 4, instruction: 'Add the carrots, swede and potatoes and continue simmering, lid ajar, until the beef falls apart and the veg is soft.', timerMinutes: 50 },
      { order: 5, instruction: 'Remove the bay leaf and thyme stalks. For baby (from 7 months): shred a little beef finely and mash it into the veg and gravy — iron-rich red meat is one of the best first proteins.', timerMinutes: null },
      { order: 6, instruction: 'Adults season their bowls at the table and mop up with crusty bread.', timerMinutes: null },
    ],
    notes: 'Cook once, feed everyone. Red meat is a top source of the iron babies need from 6 months, and long slow cooking makes it soft enough to gum. Low-salt stock keeps the pot baby-safe. Even better the next day; freezes for 3 months.',

    communityRating: 4.8,
    communityRatingCount: 90,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2026-08-01').toISOString(),
  },
];

export default familyBabyRecipes;
